<template>
  <div class="dashboard">
    <heading v-if="event" :title="event.title + ', Dashboard'"></heading>
    <!-- <div class="progress">
      <p>{{ tickets.sold }} Tickets Sold / {{ tickets.total }}</p>
      <div class="bar_holder">
        <div class="bar" :style="{ width: progress }"></div>
      </div>
    </div> -->
    <div class="stats small">
      <div class="card">
        <p class="stat">
          {{ stats.attendees }}
          <span>Paid Attendees</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          <!-- {{ stats.attendees }} -->
          50
          <span>Paid Exhibitors</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          {{ stats.attendees }}
          <span>Guests</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          {{ stats.speakers }}
          <span>Speakers</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          {{ stats.attendees }}
          <span>Sponsors</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          {{ stats.sessions }}
          <span>Agendas</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          {{ stats.orders }}
          <span>Orders</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          {{ stats.num_emails_sent }}
          <span>Emails Sent</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          ${{ stats.revenue }}
          <span>Gross Sales of Paid Attendees</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          ${{ stats.revenue }}
          <span>Gross Sales of Paid Exhibitors</span>
        </p>
      </div>

      <div class="card">
        <p class="stat">
          50/{{ stats.sessions }}
          <span>Total Check-In Attendees</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          50/{{ stats.sessions }}
          <span>Total Check-In Exhibitors</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          {{ stats.tickets_sold }}
          <span>Tickets Sold</span>
        </p>
      </div>
      <div class="card">
        <p class="stat">
          {{ tickets.total - tickets.sold }}
          <span>Tickets Remaining</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import Title from "@/components/Title.vue";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "Dashboard",
  props: ["event"],
  components: {
    heading: Title,
  },
  data() {
    return {
      stats: {
        orders: 0,
        tickets_sold: 0,
        revenue: 0,
        attendees: 0,
        speakers: 0,
      },
      tickets: {
        sold: 0,
        total: 0,
      },
      progress: "0%",
    };
  },
  computed: {},
  async created() {
    let event_id = this.event.id;
    await this.getOrder(event_id);
    await this.getTicket(event_id);
    await this.getAnalytics(event_id);
    setTimeout(() => {
      this.calcProgress();
    }, 1000);
  },
  methods: {
    calcProgress() {
      this.progress = (this.tickets.sold / this.tickets.total) * 100 + "%";
    },
    async getAnalytics(event_id) {
      let tickets_sold;
      return db
        .collection("event_analytics")
        .doc(event_id)
        .get()
        .then((res) => {
          let event = res.data();
          this.stats.revenue = event.gross_amount;
          this.stats.tickets_sold = event.tickets_sold;
          this.stats.attendees = event.num_guests;
          this.stats.sessions = event.num_sessions;
          this.stats.sponsors = 100;
          this.stats.speakers = 50;
          this.stats.num_emails_sent = 3;
          let tickets_remaining = 0;
        });
    },
    async getOrder(event_id) {
      await db
        .collection("event")
        .doc(event_id)
        .collection("orders")
        .get()
        .then((snapshot) => {
          this.stats.orders = snapshot.docs.length;
          snapshot.docs.map((d) => {
            let order = d.data();
            this.tickets.sold += order.ticket_amount
              ? order.ticket_amount
              : order.ticket_num;
          });
        });
    },
    getTicket(event_id) {
      db.collection("event")
        .doc(event_id)
        .collection("ticket")
        .get()
        .then((snapshot) => {
          snapshot.docs.map((d) => {
            let ticket = d.data();
            this.tickets.total += parseInt(ticket.quantity);
          });
        });
    },
  },
};
</script>

<style lang="scss">
.progress {
  p {
    font-size: 15px;
    margin-bottom: 5px;
  }

  .bar_holder {
    position: relative;
    height: 10px;
    width: 100%;
    max-width: 300px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 10px;
    overflow: hidden;
    background: #f9f9f9;
    border: 1px solid #eaeaea;

    .bar {
      background: #fba500;
      height: 100%;
      position: absolute;
      left: 0;
      width: 0%;
      transition: width 1s ease-in-out;
    }
  }
}
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    .stat {
      font-size: 80px;
      color: #fba500;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
  &.small {
    justify-content: flex-start;
    .card {
      width: 170px !important;
      margin-right: 20px;
      padding-top: 30px;
      padding: 20px;
      .stat {
        font-size: 46px;
        span {
          font-size: 14px;
          margin-top: -5px;
        }
      }
    }
  }
}
</style>
